module.exports = __webpack_public_path__ + "static/img/visa-head-bg.8b2f31c9.png";